//#region src/index.ts
function normalizedUnitValue(value, minimum, maximum, field) {
	if (!Number.isFinite(value)) throw new Error(`Memory ${field} must be a finite number.`);
	return Math.min(maximum, Math.max(minimum, value));
}
/** Applies bounded explicit annotations and preserves idempotency for unchanged values. */
function annotateMemoryRecord(record, annotation, now = Date.now()) {
	const kind = annotation.kind ?? record.kind;
	const importance = annotation.importance === void 0 ? record.importance : normalizedUnitValue(annotation.importance, 0, 1, "importance");
	const emotionalWeight = annotation.emotionalWeight === void 0 ? record.emotionalWeight : normalizedUnitValue(annotation.emotionalWeight, -1, 1, "emotional weight");
	if (kind === record.kind && importance === record.importance && emotionalWeight === record.emotionalWeight) return record;
	return {
		...record,
		kind,
		importance,
		emotionalWeight,
		updatedAt: now
	};
}
//#endregion
export { annotateMemoryRecord };
